module.exports = __webpack_public_path__ + "img/ereszkalkulator_25_bilics_merete_rovid_szurke.7bf34cd9.png";